import { UIPatchNotes } from '../../../../../shared/scripts/patch_notes/UIPatchNotes.ts';
export class UIDPatchNotesSceneController {
    hide() {
        this.patchNotesSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.patchNotesSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.patchNotesSceneContainerDiv = document.getElementById('scene_discord_patch_notes_container');
        const sidebar = this.patchNotesSceneContainerDiv.querySelector('#patch_note_sidebar');
        sidebar.style.flexBasis = '240px';
        new UIPatchNotes(sidebar);
    }
}
